module.exports = __webpack_public_path__ + "img/google-play-badge-ok.bc8139d4.png";